import { Box, Typography } from "@mui/material";
import { t } from "i18next";
import EditIcon from "@mui/icons-material/Edit";
import {
    BasicTableRowStyles,
    TableHeaderWrapper,
    TableWrapper,
} from "../../../components/common/Common.styles";
import CellBox from "../../../components/common/table/CellBox";
import BorderRow from "../../../components/common/table/BorderRow";
import DeleteBtn from "../../../components/common/table/DeleteBtn";
import ServerSideTableColumnHeader from "../../../components/common/table/ServerSideTableColumnHeader";
import { GeneralButton } from "../../../common/ui/GeneralButton";
import { theme } from "../../../theme";
import { StatusLevel } from "../../../types/serviceModuleTypes";

interface Props {
    levels: StatusLevel[];
    canEdit: boolean;
    handleEditLevel: (level: StatusLevel) => void;
    handleDeleteLevel: (level: StatusLevel) => void;
}

const formatRange = (level: StatusLevel): string =>
    level.maxPoints === null
        ? `${level.minPoints}+`
        : `${level.minPoints} – ${level.maxPoints}`;

export default function StatusLevelsTable(props: Props) {
    const sortedLevels = [...props.levels].sort((a, b) => a.minPoints - b.minPoints);

    return (
        <TableWrapper columnsTemplate="auto 2fr 2fr 1fr auto">
            <TableHeaderWrapper>
                <ServerSideTableColumnHeader
                    isSorted={false}
                    label={t("serviceModulesPage.statusPage.columns.color")}
                    firstCol
                />
                <ServerSideTableColumnHeader
                    isSorted={false}
                    label={t("serviceModulesPage.statusPage.columns.name")}
                />
                <ServerSideTableColumnHeader
                    isSorted={false}
                    label={t("serviceModulesPage.statusPage.columns.range")}
                />
                <ServerSideTableColumnHeader
                    isSorted={false}
                    label={t("serviceModulesPage.statusPage.columns.payoutPoints")}
                />
                <BorderRow />
            </TableHeaderWrapper>

            {sortedLevels.map((level) => (
                <BasicTableRowStyles key={level.id}>
                    <CellBox firstCol contentPosition="flex-start">
                        <Box
                            sx={{
                                width: "24px",
                                height: "24px",
                                borderRadius: "50%",
                                backgroundColor: level.colorHex,
                                border: `2px solid ${theme.palette.divider}`,
                            }}
                        />
                    </CellBox>
                    <CellBox contentPosition="flex-start">
                        <Typography>{level.name}</Typography>
                    </CellBox>
                    <CellBox contentPosition="flex-start">
                        <Typography>{formatRange(level)}</Typography>
                    </CellBox>
                    <CellBox contentPosition="flex-start">
                        <Typography>{level.payoutPoints}</Typography>
                    </CellBox>
                    <CellBox lastCol>
                        {props.canEdit && (
                            <>
                                <GeneralButton
                                    appVariant="icon"
                                    onClick={() => props.handleEditLevel(level)}
                                >
                                    <EditIcon />
                                </GeneralButton>
                                <DeleteBtn
                                    isCreateNewMode={false}
                                    dialogMessage={t("serviceModulesPage.statusPage.confirmDelete")}
                                    handleOnDelete={() => props.handleDeleteLevel(level)}
                                />
                            </>
                        )}
                    </CellBox>
                    <BorderRow />
                </BasicTableRowStyles>
            ))}
        </TableWrapper>
    );
}
